export const trimIfString = <T = string>(str: T) => {
    if (typeof str === 'string') {
        return str.trim();
    }
    return undefined;
};
